import {Routes} from "@angular/router";

export const ProvidersRoutes: Routes = [
    {
        path: "",
        loadComponent: () =>
            import("../pages/suppliers/suppliers.page").then(
                (m) => m.SuppliersPage
            ),
    },
    {
        path: "company-container",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/auth/company/pages/company-container/company-container.page").then(
                        (m) => m.CompanyContainerPage
                    ),
            },
            {
                path: "company-edit",
                loadComponent: () =>
                    import("@/app/domains/auth/company/pages/company-edit/company-edit.page").then(
                        (m) => m.CompanyEditPage
                    ),
            },
            {
                path: "branch-edit",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("@/app/domains/auth/company/pages/branch-edit/branch-edit.page").then(
                                (m) => m.BranchEditPage
                            ),
                    },
					{
						path: "address-container",
						children: [
							{
								path: "",
								loadComponent: () =>
									import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
										(m) => m.AddressContainerPage
									),
							},
							{
								path: "address-edit",
								loadComponent: () =>
									import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
										(m) => m.AddressEditPage
									),
							},
						],
					},
                ]
            },
        ]
    },
    {
        path: "natural-person-edit",
        loadComponent: () =>
            import("@/app/domains/shared/persons/pages/natural-person-edit/natural-person-edit.page").then(
                (m) => m.NaturalPersonEditPage
            ),
    },
    // «Direcciones» de una persona proveedora: natural-person-edit navega relativo a su ruta (igual que en customers.routes.ts).
    {
        path: "natural-person-edit/address-container",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
                        (m) => m.AddressContainerPage
                    ),
            },
            {
                path: "address-edit",
                loadComponent: () =>
                    import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
                        (m) => m.AddressEditPage
                    ),
            },
        ],
    },
    // {
    //     path: "address-container",
    //     children: [
    //         {
    //             path: "",
    //             loadComponent: () =>
    //                 import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
    //                     (m) => m.AddressContainerPage
    //                 ),
    //         },
    //         {
    //             path: "address-edit",
    //             loadComponent: () =>
    //                 import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
    //                     (m) => m.AddressEditPage
    //                 ),
    //         },
    //     ],
    // },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
